import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import ProductSidebar from 'components/ProductSidebar';
import PDFBox from 'components/PDFBox';
import {
    fetchTrialResults,
    fetchTrialResultsDetail,
    selectTrialResultsDetail,
    selectTrialResultsPage,
} from 'store/slices/TrialResults';

// TODO NOT DONE!
const DetailedTrialResults = () => {
    const dispatch = useDispatch();
    const { slug } = useParams();

    const { title, trials } = useSelector(selectTrialResultsDetail);
    const { crops = [] } = useSelector(selectTrialResultsPage);
    const sidebarCrops = crops.filter(item => item.slug !== slug);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchTrialResults());
        // @ts-ignore
        dispatch(fetchTrialResultsDetail({ slug }));
    }, [dispatch, slug]);

    return (
        <>
            <Banner title={title} image={''} buttonText="!!!!" />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={<ProductSidebar title="!!!" data={sidebarCrops} />}
                >
                    <PDFBox data={trials} />
                </WithSidebar>
            </section>
        </>
    );
};

export default DetailedTrialResults;
